<div class="layout">
  <aside class="sidebar">
    <a routerLink="/tournaments" class="brand">ECL Vault</a>

    @if (hasEnvironmentBadge()) {
      <p class="environment-badge">{{ environmentBadgeLabel }}</p>
    }

    <section class="menu-group">
      <h2>{{ t('nav.public') }}</h2>
      <nav>
        <a routerLink="/tournaments" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">{{ t('nav.tournaments') }}</a>
        <a routerLink="/information" routerLinkActive="is-active">{{ t('nav.information') }}</a>
        <a routerLink="/hall-of-fame" routerLinkActive="is-active">{{ t('nav.hallOfFame') }}</a>
      </nav>
    </section>

    @if (hasPlayerSession()) {
      <section class="menu-group">
        <h2>{{ t('nav.player') }}</h2>
        <nav>
          <a routerLink="/player/me" routerLinkActive="is-active">{{ t('nav.profile') }}</a>
          <a routerLink="/player/matches" routerLinkActive="is-active">{{ t('nav.myMatches') }}</a>
          <a routerLink="/player/teams" routerLinkActive="is-active">{{ t('nav.myTeams') }}</a>
          <a routerLink="/player/teams/create" routerLinkActive="is-active">{{ t('nav.createTeam') }}</a>
          <a routerLink="/player/invitations" routerLinkActive="is-active">{{ t('nav.invitations') }}</a>
        </nav>
      </section>
    }

    @if (hasBackofficeSession()) {
      <section class="menu-group">
        <h2>{{ t('nav.backoffice') }}</h2>
        <nav>
          <a routerLink="/backoffice/tournaments" routerLinkActive="is-active">{{ t('nav.boTournaments') }}</a>
          <a routerLink="/backoffice/registrations" routerLinkActive="is-active">{{ t('nav.boRegistrations') }}</a>
          <a routerLink="/backoffice/score-reports" routerLinkActive="is-active">{{ t('nav.boScoreReports') }}</a>
        </nav>
      </section>
    }
  </aside>

  <main class="content">
    <header class="content-topbar">
      <div class="lang-switch" aria-label="Language switch">
        <button type="button" [class.is-active]="isLanguage('fr')" (click)="setLanguage('fr')">FR</button>
        <span>/</span>
        <button type="button" [class.is-active]="isLanguage('en')" (click)="setLanguage('en')">EN</button>
      </div>

      @if (!hasAnySession()) {
        <div class="session-group">
          <a routerLink="/login">{{ t('topbar.login') }}</a>
          <a routerLink="/player/register">{{ t('topbar.register') }}</a>
        </div>
      } @else if (hasPlayerSession() && !hasBackofficeSession()) {
        <div class="session-group">
          <span class="identity-badge">{{ playerIdentityLabel() }}</span>
          <button type="button" (click)="logout()">{{ t('topbar.playerLogout') }}</button>
        </div>
      } @else if (hasBackofficeSession() && !hasPlayerSession()) {
        <div class="session-group session-group--bo">
          <span class="identity-badge identity-badge--bo">{{ backofficeIdentityLabel() }}</span>
          <button type="button" (click)="backofficeLogout()">{{ t('topbar.boLogout') }}</button>
        </div>
      } @else {
        <p class="session-note">{{ t('topbar.doubleSession') }}</p>
        <div class="session-group">
          <span class="identity-badge">{{ playerIdentityLabel() }}</span>
          <button type="button" (click)="logout()">{{ t('topbar.playerLogout') }}</button>
        </div>
        <div class="session-group session-group--bo">
          <span class="identity-badge identity-badge--bo">{{ backofficeIdentityLabel() }}</span>
          <button type="button" (click)="backofficeLogout()">{{ t('topbar.boLogout') }}</button>
        </div>
      }
    </header>

    <router-outlet></router-outlet>
  </main>
</div>
